// Inline the assembled prototype file tree into ONE srcdoc document so the preview can run
// inside a sandboxed iframe (allow-scripts ONLY — no allow-same-origin, so generated code can
// never touch the host origin, its storage, or the Supabase session). Pure — unit-tested
// without the api module.
export function buildSrcdoc(files) {
  let html = files['index.html'] || '';
  const iconUri = `data:image/svg+xml,${encodeURIComponent(files['icon.svg'] || '')}`;
  html = html.replace('<link rel="stylesheet" href="style.css">', `<style>\n${files['style.css'] || ''}\n</style>`);
  html = html.replace('<script src="spec.js"></script>', `<script>\n${files['spec.js'] || ''}\n</script>`);
  html = html.replace('<script src="app.js"></script>', `<script>\n${files['app.js'] || ''}\n</script>`);
  html = html.replace('<link rel="manifest" href="manifest.webmanifest">', '');
  html = html.replaceAll('src="icon.svg"', `src="${iconUri}"`);
  html = html.replace('<link rel="icon" href="icon.svg" type="image/svg+xml">', '');
  return html;
}
